var React = require('react');

function ScheduleInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor"},React.createElement("path",{"d":"M23 6h-2c-.553 0-1-.447-1-1s.447-1 1-1h2c.553 0 1 .447 1 1s-.447 1-1 1zM17 6H1c-.553 0-1-.447-1-1s.447-1 1-1h16c.553 0 1 .447 1 1s-.447 1-1 1zM3 13H1c-.553 0-1-.447-1-1s.447-1 1-1h2c.553 0 1 .447 1 1s-.447 1-1 1zM23 13H7c-.553 0-1-.447-1-1s.447-1 1-1h16c.553 0 1 .447 1 1s-.447 1-1 1zM23 20h-2c-.553 0-1-.447-1-1s.447-1 1-1h2c.553 0 1 .447 1 1s-.447 1-1 1zM17 20H1c-.553 0-1-.447-1-1s.447-1 1-1h16c.553 0 1 .447 1 1s-.447 1-1 1z"})));
}

ScheduleInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ScheduleInline;

ScheduleInline.default = ScheduleInline;
